import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import CustomerAppointment from "./CustomerAppointment";
import CustomerDetails from "./CustomerDetails";
import CustomerLogs from "./CustomerLogs";
import CustomerStatus from "./CustomerStatus";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";
import { useParams } from "react-router-dom";
import {
  GetCustomerContact,
  GetCustomerDetail,
} from "../../../store/async-actions/digitalmarketing/customer";
import { resetReducer } from "../../../store/reducers/digitalmarketing/customer";
import { useGetCustomerQuery } from "../../../Service/customers";
import { useGetCustomerContactQuery } from "../../../Service/customerContact";
import { useGetCustomerMedicalQuery } from "../../../Service/customerMedical";
import {
  useGetDashboardCustomerJourneyTypesQuery,
  useGetDashboardHealthIssuessQuery,
  useGetDashboardRemindedForQuery,
  useGetDashboardRemindedToQuery,
  useGetDashboardStatusesQuery,
} from "../../../Service/dashboard";
import CustomerJourney from "./CustomerJourney";
import { useGetCustomerLogByCustomerIdQuery } from "../../../Service/CustomerLogs";
import { useGetCustomerAppointmentByCustomerIdQuery } from "../../../Service/CustomerAppointment";
import { useGetCustomerJourneyByCustomerIdQuery } from "../../../Service/CustomerJourney";
import {
  useGetCustomerReminderByCustomerIdQuery,
  useGetCustomerReminderHistoryQuery,
  useGetCustomerRemindersQuery,
} from "../../../Service/CustomerReminder";
import CustomerReminder from "./CustomerReminder";
import CustomerRemiderDetail from "./CustomerRemiderDetail";
import { specialChractorValidation } from "./Utils/validation";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import CustomerReminderHistory from "./CustomerReminderHistory";
import JourneyStatus from "./AddJourneyStage";
import { SettingsTabs } from "./Utils";
import Tabs from "./Component/Tabs";
import Prescription from "./Prescription";
import TestReports from "./TestReports";
import IvfJourney from "./IvfJourney";
import {
  useGetIVFJourneyCurrentStageQuery,
  useGetIVFJourneymasterQuery,
} from "../../../Service/ivfJourneyStage";
import { useGetAppoinmentLeadbyIdQuery } from "../../../Service/appoinment";
import NewAppoinment from "../Appoinment/NewAppointments/NewAppoinments";
import { BsPlusLg } from "react-icons/bs";
function Customer() {
  const { id } = useParams();
  const dispatch = useDispatch<any>();
  // console.log("test",window.location.pathname.split("/")[2]);
  const view = window.location.pathname.split("/")[2] === "customerview";

  const [active, setActive] = useState(1);
  const [customerId, setcustomerId] = useState("110");
  const [showAppointment, setShowAppointment] = useState<boolean>(false);
  const [show, setshow] = useState<boolean>(false);
  const getHealthIssue = useGetDashboardHealthIssuessQuery();
  const getStatus = useGetDashboardStatusesQuery();
  const getCustomerJouney = useGetDashboardCustomerJourneyTypesQuery();
  const getRemindedFor = useGetDashboardRemindedForQuery();
  const getReminderTo = useGetDashboardRemindedToQuery();

  // const getRminderForAppointment = useGetCustomerRemindersQuery(null, { refetchOnMountOrArgChange: true });
  const CustomerReminderDetail = useSelector(
    (state: any) => state.customer.customerReminder
  );

  const CustomerDetail = useSelector(
    (state: any) => state.customer.customerDetail
  );
  // console.log(CustomerDetail);
  const { data: journeys, refetch } = useGetIVFJourneymasterQuery(
    { id: id || CustomerDetail.id },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const { data: currentStage, refetch: refetchcurrentstage } =
    useGetIVFJourneyCurrentStageQuery(
      { id: id || CustomerDetail.id },
      {
        refetchOnMountOrArgChange: true,
      }
    );
  // console.log("currentStage",currentStage);
  const { data: CurrentAppointment, refetch: refetchappointmentstage } =
    useGetAppoinmentLeadbyIdQuery(
      { id: id || CustomerDetail.id },
      {
        refetchOnMountOrArgChange: true,
      }
    );
  // console.log(CurrentAppointment);

  const [errorMessage, setErrorMessage] = useState(false);
  const { open, message, openSnackBar, type } = useSnackbar();
  const CustomerAppointmentDetail = useSelector(
    (state: any) => state.customer.customerAppointment
  );
  useEffect(() => {
    const data: any = {
      first: "Lead Management"
    };
    dispatch(Change(data));
    dispatch(resetReducer());
    if (id) {
      // dispatch(GetCustomerContact(id));
      // dispatch(GetCustomerDetail(id));
    } else {
      dispatch(resetReducer());
    }
  }, [dispatch, id]);
  const account = useSelector((state: any) => state.auth);

  const callBackforErrorMessage = (value = true) => {
    setErrorMessage(value);
    if (specialChractorValidation(CustomerDetail?.customerName)) {
      return "special character not allowed in user name field";
    } else return "please enter patient name !..";
  };

  let autoResize = () => {
    if (window.innerWidth > 991 || window.innerWidth < 646) {
      setshow(false);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", autoResize);
    autoResize();
    refetch();
  }, []);
  return (
    <React.Fragment>
      <Toast open={open} type={type} message={message} />
      {/* {CustomerDetail.id && account.permissions.ivf_journey_status===1 &&     <Tabs tablist={SettingsTabs} setActive={setActive} active={active} />
} */}
      {/* {active === 1 && ( */}
      <div className="customer-main">
        <div className={show ? "Customer-details-short " : "Customer-details"}>
          {show ? (
            <>
              <img
                src={require("../../../assets/DigitalMarketing/image/customer/user.png")}
                alt=""
                className="customer-right-icon"
                width="15"
              />
              <br></br>
              <HiOutlineChevronDoubleRight
                className="customer-right-icon cursor"
                onClick={() => setshow(!show)}
              />
            </>
          ) : (
            ""
          )}
          <ul className="md-bord">
            <CustomerDetails
              id={id}
              view={view}
              setshow={setshow}
              openSnackBar={openSnackBar}
              callBackforErrorMessage={callBackforErrorMessage}
              errorMessage={errorMessage}
            />
          </ul>
        </div>

        <div className="Customer-position">
          <div className="status">
            <ul className="status-ul md-bord">
              <CustomerStatus
                view={view}
                openSnackBar={openSnackBar}
                callBackforErrorMessage={callBackforErrorMessage}
              />
            </ul>
          </div>

          <div className={show ? "logs log-hide" : "logs log-show"}>
            <ul className="logs-ul md-bord">
              <li>
                <CustomerLogs
                  view={view}
                  openSnackBar={openSnackBar}
                  callBackforErrorMessage={callBackforErrorMessage}
                />
              </li>
            </ul>
            {/* <ul className="reminder md-bord">
              <li className="mt-2">
                <CustomerReminder
                  openSnackBar={openSnackBar}
                  callBackforErrorMessage={callBackforErrorMessage}
                />
              </li>
            </ul> */}
            {/* <ul className="reminder md-bord">
              <li className="mt-2">
                <CustomerReminderHistory
                  id={id}
                  openSnackBar={openSnackBar}
                  callBackforErrorMessage={callBackforErrorMessage}
                />
              </li>
            </ul> */}
          </div>

          {CurrentAppointment?.length !== 0 && (
            <div className="Appointment">
              <ul className="Appointment-ul md-bord">
                <CustomerAppointment
                  openSnackBar={openSnackBar}
                  currentStage={currentStage}
                  id={id}
                  callBackforErrorMessage={callBackforErrorMessage}
                />
              </ul>
            </div>
          )}
          {CustomerReminderDetail.id && (
            <div className="Appointment">
              <ul className="Appointment-ul md-bord">
                <CustomerRemiderDetail
                  openSnackBar={openSnackBar}
                  data={CustomerReminderDetail}
                  id={id}
                  callBackforErrorMessage={callBackforErrorMessage}
                />
              </ul>
            </div>
          )}
          {/* <div className="status-ul md-bord">
<JourneyStatus
             openSnackBar={openSnackBar}
             callBackforErrorMessage={callBackforErrorMessage}
       /></div> */}
          {/* {account.permissions.ivf_journey_status === 1 && ( */}
          <div className="journey md-bord ">
                <IvfJourney
                  openSnackBar={openSnackBar}
                  currentStage={currentStage}
                  id={id}
                  callBackforErrorMessage={callBackforErrorMessage}
                  refetchcurrentstage={refetchcurrentstage}
                  journeys={journeys}
                  refetch={refetch}
                />
              </div>
          <div className="journey md-bord mt-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="f-18 fw-500 fw-bold">Appointment</span>
              </div>
              <button
                id="btn-blue"
                onClick={() => setShowAppointment(true)}
                disabled={view}
              >
                <BsPlusLg />
              </button>
            </div>
          </div>
          <div className="journey md-bord mt-4">
            <CustomerJourney
              id={id}
              openSnackBar={openSnackBar}
              callBackforErrorMessage={callBackforErrorMessage}
            />
          </div>
        </div>
        <div className={show ? "logs" : "logs log-hide"}>
          <ul className="logs-ul md-bord">
            <li>
              <CustomerLogs
                openSnackBar={openSnackBar}
                callBackforErrorMessage={callBackforErrorMessage}
              />
            </li>
          </ul>
          {/* <ul className="reminder md-bord">
            <li className="mt-2">
              <CustomerReminder
                openSnackBar={openSnackBar}
                callBackforErrorMessage={callBackforErrorMessage}
              />
            </li>
          </ul> */}
          {/* <ul className="reminder md-bord">
            <li className="mt-2">
              <CustomerReminderHistory
              id={id}
                openSnackBar={openSnackBar}
                callBackforErrorMessage={callBackforErrorMessage}
              />
            </li>
          </ul> */}
        </div>
      </div>
      {/* )} */}
      {/* {active === 2 && (
        <>
          <Prescription CustomerDetail={CustomerDetail} />
        </>
      )}
      {active === 3 && <TestReports CustomerDetail={CustomerDetail} />} */}
      <NewAppoinment
        showAppointment={showAppointment}
        setShowAppointment={setShowAppointment}
        customerId={id || CustomerDetail?.id}
      />
    </React.Fragment>
  );
}

export default Customer;
